import React, { useState, useEffect } from 'react';
import { get, post } from '../Services/http';
import { string, object } from 'yup';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import DatePickerInput from './DatePickerInput';
import "react-datepicker/dist/react-datepicker.css";
import { translate } from '../Services/translation';
import AddToCalendar from 'react-add-to-calendar';
import { storeIdConverter } from '../Services/StoreId.service';
import { useDispatch } from 'react-redux';
import CustomSelect from './bookingForm/CustomSelect';
import enGB from 'date-fns/locale/en-GB';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import 'add-to-calendar-button';

const BookingFormEmbedded = ({ showMember, member, onReturn, currentStore, domainName, allowSelectResource, isUserRequest }) => {
    const [bookingData, setBookingData] = useState({});
    const [selectedDayTimes, setSelectedDayTimes] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [currentMembers, setCurrentMembers] = useState([]);
    const [isSuccessForm, setIsSuccessForm] = useState(false);
    const [successFormData, setSuccessFormData] = useState({});
    const [formParams, setFormParams] = useState({});
    const [errors, setErrors] = useState({});
    const [availableDates, setAvailableDates] = useState([]);
    const [validationOnChanges, setValidationOnChanges] = useState(false);
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState('');
    

    // const domainName = 'http://coptikk.test.workplace.nu';
    const getallbookingtypesformember = (memberId) => domainName + `/api/booking/getallbookingtypesformember?memberId=${memberId}`;
    const getbookabletimes = (memberId, bookingTypeId) => domainName + `/api/booking/getbookabletimes?memberId=${memberId}&bookingTypeId=${bookingTypeId}`;
    const createbooking = (memberId) => domainName + `/api/booking/createbooking?memberId=${memberId}`;

    const selectCurrentMembers = (members, onChange) => <form>
        {members.map(({ bookingTypeId, memberId, name, durationInMinutes, description, price, ...other }) =>
            <div className="cop__member__wrapper" key={memberId + name}>
                <label className="container">
                    <input type="radio" id={memberId} name="member" className="cop__member__radio"
                        onChange={() => onChange({ bookingTypeId, memberId, name, durationInMinutes, description, price, ...other })} />
                    <span className="checkmark"></span>
                </label>
                <div>
                    <div className="cop__member__name">{name} ({price}kr)</div>
                    <div className="cop__member__description">{description}</div>
                </div>
            </div>
        )}
    </form>

    const getTimes = async (memberId, bookingTypeId, fromRaw, year = 0) => {
        const _from = new Date(fromRaw);
        const from = _from.toISOString();
        const to = new Date(_from.setFullYear(_from.getFullYear() + year)).toISOString();
        const response = await post(getbookabletimes(memberId, bookingTypeId), { from, to }, null, 'omit');
        const { OnlineBookableTime } = await response.json();
        return OnlineBookableTime;
    }

    const requiredErrorWrapper = (field, message) => <>
        <div className={`${field && field.type === 'required' ? "form_error__wrapper" : "none"}`}>
            {message}
            <div className="form_error__triangle" />
            <div className="form_error">
                {field && field.type === 'required' && message}
            </div>
        </div>
    </>
    const emailErrorWrapper = (field, message) => <>
        <div className={`${field && !field.type ? "form_error__wrapper" : "none"}`}>
            {message}
            <div className="form_error__triangle" />
            <div className="form_error">
                {field && !field.type && message}
            </div>
        </div>
    </>
    const lengthErrorWrapper = (field, message) => <>
        <div className={`${field && field.type !== 'required' ? "form_error__wrapper" : "none"}`}>
            {message}
            <div className="form_error__triangle" />
            <div className="form_error">
                {field && field.type !== 'required' && message}
            </div>
        </div>
    </>;
    const getCurrentMembers = async (memberId) => {
        const response = await get(getallbookingtypesformember(memberId), null, 'omit');
        return await response.json();
    }

    const createNewBooking = async ({ memberId, startAt, resourceId, bookingTypeId, message, sendSmsConfirmation, firstName, lastName, phoneNumber, email, ssn }) => {
        const dataForBooking = {
            startAt,
            resourceId,
            bookingTypeId,
            message,
            sendSmsConfirmation,
            customer: {
                firstName,
                lastName,
                phoneNumber,
                ssn
            }
        };
        if (email !== '') {
            dataForBooking.customer.email = email;
        }
        const response = await post(createbooking(memberId), dataForBooking, null, 'omit');
        return await response.json();
    }

    const getTimesByDateAndYear = async ({ memberId, bookingTypeId }, date, year = 0) => await getTimes(memberId, bookingTypeId, date, year);

    const uniq = (value, index, self) => self.indexOf(value) === index;
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const formatNorwayDate = startAt => {
        const a = new Date(startAt).toLocaleDateString('nb-NO', options).toString();        
        const position = -6;
        return capitalizeFirstLetter([a.slice(0, position), a.slice(position)].join(''));
    }
    const successForm = (successFormData, currentStore, onReturn) => {
        return <>
            <h1 className='cop__booking-form__title'>{isUserRequest ? "Takk for din forespørsel," : "Takk for din bestilling"} {successFormData && successFormData.customer && successFormData.customer.firstName}!</h1>

            <div className='cop__booking-form__success'>
                <div className="row">
                    <div className="column small-12 cop__booking-form__success__header">{currentStore.storeName}</div>
                    <div className="column small-12">{currentStore.storeAddress}, {currentStore.storePostalCode} {currentStore.storeCity}</div>
                    <div className="column small-12"><div className='phone_bold'>{currentStore && currentStore.storePhone && `${currentStore.storePhone.toString().replace(" ", "").replace(/\B(?=(\d{2})+(?!\d))/g, " ")}`}</div></div>
                    <div className="column small-12"><div className="cop__separator" /></div>
                    <div className="column small-12 cop__booking-form__success__item"><b>{translate("coptikk.booking.optician")}</b>{successFormData && successFormData.resource && successFormData.resource.name}<br /><b>Tid</b>: {successFormData && successFormData.startAt && formatNorwayDate(successFormData.startAt)} </div>
                    <div className="column small-12 cop__booking-form__success__item">{translate("coptikk.booking.remindertext")}</div>
                    <div className="column small-12">
                        <div className=''>                            
                            <AddToCalendarButton
                                name={`Optiker: ${successFormData && successFormData.resource && successFormData.resource.name ? successFormData.resource.name : ""}. Tid: ${successFormData && successFormData.startAt ? formatNorwayDate(successFormData.startAt) : ""}`}
                                startDate={successFormData.startAt.substring(0,10)}
                                startTime={successFormData.startAt.substring(11, 16)}
                                endTime={successFormData.endAt.substring(11, 16)}
                                timeZone="Europe/Stockholm"
                                location=""
                                options={['Google','Apple','Outlook.com','iCal']}
                                trigger="click"          // open on click (not hover)
                                listStyle="overlay"      // render above layout
                                forceOverlay             // bypass parent overflow/z-index issues
                                debug                    // log config errors in console
                                label={translate("coptikk.booking.addtocalendar")}
                                styleLight={{
                                    '--btn-background': '#C7DEE5',   
                                    '--btn-text': '#161616',         
                                    '--btn-border-radius': '20px',
                                    '--btn-padding': '0.6666666667rem 1.3333333333rem 0.8rem',
                                    '--btn-width': '100%'           // custom width
                                  }}
                            />
                            
                            </div>
                    </div></div>
            </div>
        </>
    }







    useEffect(() => {
        const getAsyncCurrentMembers = async () => {
            const memberId = member && member.memberId;
            if (memberId) {
                //? This code only for test comment this line.
                // setCurrentMembers([{ "bookingTypeId": "c9b6ed2e-1afe-441d-8c37-a1dcf5974bb4", "memberId": 919, "name": "Utvidet synsundersøkelse inkl OCT", "durationInMinutes": 60, "description": "Dette er vår anbefalte synsundersøkelse om du ikke har sjekket øynene siste 2 årene. Inneholder måling av brillestyrke og undersøkelse av din øyehelse. Det inkluderer øyetrykk, OCT-scann av netthinne, samsynsundersøkelse og andre målinger ved behov. (60min)", "price": 950.0 }, { "bookingTypeId": "2f3cb07d-cf27-489e-89da-22a4f2d5f87e", "memberId": 919, "name": "Barnesynsprøve 5-13år", "durationInMinutes": 90, "description": "Ved synsprøve på barn er det ofte nødvendig å dryppe med øyedråper som vil gi store pupiller og dårlig syn på nær avstand. Dette vil vare noen timer etter undersøkelsen. Mer informasjon blir gitt når du er her. (90min)", "price": 750.0 }, { "bookingTypeId": "5af8ea4c-a09a-4c59-8ee3-3a129830b863", "memberId": 919, "name": "Nytilpasning linser", "durationInMinutes": 60, "description": "Inkluderer opplæring og èn etterkontroll (60min)", "price": 950.0 }, { "bookingTypeId": "c6332dfc-c32b-49c1-ba11-8a9e3facbec9", "memberId": 919, "name": "Synsundersøkelse basis", "durationInMinutes": 60, "description": "I denne undersøkelsen måler vi ut din brillestyrke. Optiker kan anbefale flere undersøkelser der det er nødvendig. (60min)", "price": 650.0 }, { "bookingTypeId": "9151faaf-4b75-475d-9fdd-d30b937011b5", "memberId": 919, "name": "Linskontroll", "durationInMinutes": 60, "description": "Standard øyehelsekontroll for etablerte linsebrukere. Optiker kan anbefale flere undersøkelser der det er nødvendig. (60min)", "price": 550.0 }, { "bookingTypeId": "d39a7f31-4374-4294-9004-ea6f9bb2fc41", "memberId": 919, "name": "Synsprøve for førerkort", "durationInMinutes": 60, "description": "Synsprøve for deg som trenger synsattest for syn til anskaffelse eller fornyelse av førerkort. Optiker kan anbefale flere undersøkelser der det er nødvendig. (60min)", "price": 550.0 }]);
                const _currentMembers = await getCurrentMembers(memberId);
                setCurrentMembers(_currentMembers);
            }
        }
        getAsyncCurrentMembers();
        registerLocale("en-GB", enGB);
        setDefaultLocale("en-GB");
    }, []);
    useEffect(() => {
        const getThisMonthDates = async () => {
            setAvailableDates(await getTimesByDateAndYear(formParams, Date.now(), 1), dispatch);
        }
        if (formParams.memberId) {
            getThisMonthDates();
            if (!allowSelectResource && bookingData.resourceId !== 'ANY') {
                onBookingOpticianChange('optician', 'ANY', 'Første ledige optiker');
            }
        }
    }, [formParams]);
    useEffect(() => {
        if (validationOnChanges) {
            validate();
        }
    }, [bookingData]);

    const onBookingDateChange = (key, value) => {
        const day = new Date(value);
        const startTime = day.getTime();
        const endOfDay = new Date(day);
        endOfDay.setDate(endOfDay.getDate() + 1);
        const endTime = endOfDay.getTime();
        const dayTimes = availableDates.filter(({ resource }) => bookingData.resourceId === 'ANY' || resource.resourceId === bookingData.resourceId)
            .filter(({ startAt }) => new Date(startAt).getTime() >= startTime && new Date(startAt).getTime() < endTime);
        setSelectedDayTimes(dayTimes);
        setSelectedDay(day);
        setBookingData(prevData => ({ ...prevData, [key]: day }));
    }
    const onBookingDataChange = (key, value) => {
        setBookingData(prevData => ({ ...prevData, [key]: value }));
        if (key == 'time') {
            if (window != null && window.dataLayer != null) {
                let trackingObject = {
                    event: "booking_planned",
                    booking_data: {
                        dateTime: bookingData.time,
                        type: formParams.bookingTypeId
                    },
                    storeId: storeIdConverter(currentStore.storeId).withC,
                    storeName: currentStore.storeName
                };
                console.log(trackingObject);
                window.dataLayer.push(trackingObject);
            }
        }
    };

    const onBookingOpticianChange = (key, resourceId, value) => {
        setSelectedDay(null);
        setSelectedDayTimes(null);
        setBookingData(prevData => ({ ...{ ...prevData, resourceId, [key]: value } }));
    };

    const getEnabledDays = () => {
        const dates = availableDates.filter(({ resource }) => bookingData.resourceId === 'ANY' || resource.resourceId === bookingData.resourceId).map(({ startAt }) => new Date(startAt));
        dates.forEach(date => date.setHours(0));
        return dates.filter(uniq);
    };
    const dayOfTheMonth = (key, c) => (e) => {
        var number = parseInt(e.target.value);
        if((key == 'dd') || (key == 'mm')) {
            if(key == 'dd') {
                if((number < 0) || (number > 31)) {
                    e.target.value = '0';
                    e.target.value = e.target.value.padStart(c, '0');
                }
                else {
                    e.target.value = number.toString();
                }
            }else if(key == 'mm') {
                if((number < 0) || (number > 12)) {
                    e.target.value = '0';
                    e.target.value = e.target.value.padStart(c, '0');
                }else {
                    e.target.value = number.toString();
                }
            }
            if(number < 10) {
                e.target.value = "0" + number.toString();
            }
        }else if(key == 'yyyy') {
            var CurrentYear = new Date().getFullYear();
            if((number < 1900) || (number > CurrentYear)) {
                e.target.value = '0';
                e.target.value = e.target.value.padStart(c, '0');
            }
            else {
                e.target.value = number.toString();
            }
        }
    };

    const storeForm = (isFullForm, bookingRequest) => {

        let selectOptions = [];

        if (allowSelectResource) {            
            if ((availableDates.length > 0)) {

                if (!currentStore.hideFirstAvailableOptician) {
                    selectOptions.push({key: "ANY", value: "Første ledige optiker", resourceId: "ANY"});                      
                }            
                
                selectOptions.push({key: "", value: "", resourceId: ""});

                {availableDates &&
                    [
                        ...new Map(availableDates
                            .map(({ resource }) => resource).map((item) => [item["resourceId"], item])).values(),
                    ]
                        .map(({ name, resourceId }) => {selectOptions.push({key: resourceId + name, value: name, resourceId: resourceId})})}
            }
        }
        else {
            if (!currentStore.hideFirstAvailableOptician) {
                selectOptions.push({key: "ANY", value: "Første ledige optiker", resourceId: "ANY"});
            }            
        }

        return <>
            <div className="cop__separator" />
            <form className="user-form" >
                {allowSelectResource ? <>
                    <div className="small-12 cop__header">Velg optiker</div>
                    <div className="small-6 store-field-wrapper optician-select-wrapper">
                        {/* <select disabled={!allowSelectResource} id="optician-native-select" class="hidden-select"
                        className={`custom-select store-select fc-primary fc-primary ${errors.optician && errors.optician.type === 'required' ? "store-field-with-error" : ""}`}
                            onChange={(event) => {
                                onBookingOpticianChange('optician', event.target.value, event.target.options[event.target.selectedIndex].text);
                                setSelectedOption(event.target.value);
                            }}>
                            {allowSelectResource ? <>
                                <option style={{ display: 'none' }}>Velg optiker</option>
                                {(availableDates.length > 0) && !currentStore.hideFirstAvailableOptician && (
 <option value='ANY'>Første ledige optiker</option>)}
                                <option disabled></option>
                                {availableDates &&
                                    [
                                        ...new Map(availableDates
                                            .map(({ resource }) => resource).map((item) => [item["resourceId"], item])).values(),
                                    ]
                                        .map(({ name, resourceId }) => <option value={resourceId} key={resourceId + name}>{name}</option>)}
                            </> : !currentStore.hideFirstAvailableOptician &&( <option value='ANY'>Første ledige optiker</option>)}
                        </select> */}

                        <div>                            
                            <CustomSelect options={selectOptions} value={selectedOption} onChange={(value, resourceId, name) => {
                                setSelectedOption(value);
                                onBookingOpticianChange('optician', resourceId, name);
                            }} />
                        </div>
                        {requiredErrorWrapper(errors.optician, 'Hvilken optiker vil du ha?')}
                    </div> </> : null}
                <div className="small-12 cop__header">Velg dato</div>
                <div className="small-6 store-field-wrapper">
                    {window.innerWidth <= 760 ?
                        <DatePicker
                            disabled={(!bookingData.resourceId)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="dd.mm.åååå"
                            selected={selectedDay}
                            locale="en-GB"
                            includeDates={getEnabledDays()}
                            onChange={(date) => onBookingDateChange('date', date)}
                            popperClassName="booking"
                            customInput={<DatePickerInput />}
                            portalId="bookingMapContainer"
                            withPortal
                        /> : <DatePicker
                            disabled={(!bookingData.resourceId)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="dd.mm.åååå"
                            selected={selectedDay}
                            locale="en-GB"
                            includeDates={getEnabledDays()}
                            onChange={(date) => onBookingDateChange('date', date)}
                            customInput={<DatePickerInput />}
                        />}
                    {requiredErrorWrapper(errors.date, 'Hvilken dag vil du ha time?')}
                </div>
                <div className="small-12 cop__header">Velg klokkeslett</div>
                <div className="small-6 store-field-wrapper">
                    <select disabled={!bookingData.date && !bookingData.resourceId} className={`custom-select store-select fc-primary ${errors.time && errors.time.type === 'required' ? "store-field-with-error" : ""}`}
                        onChange={(event) => onBookingDataChange('time', selectedDayTimes && selectedDayTimes[event.target.value])}>
                        <option key="none" style={{ display: 'none' }}>Velg klokkeslett</option>
                        {selectedDayTimes &&
                            selectedDayTimes
                                .map((obj, i) => ({ ...obj, i }))
                                .filter(({ resource }) => resource.resourceId === bookingData.resourceId || bookingData.resourceId === 'ANY')
                                .sort((a, b) => (new Date(a.startAt).getTime()) - (new Date(b.startAt).getTime()))
                                .filter((value, index, self) => self.findIndex(v => (v.startAt === value.startAt) && (v.endAt === value.endAt)) === index)
                                .map(({ startAt, endAt, i, ...other }) => <option key={startAt} value={i}>{`${formatDate(startAt)} - ${formatDate(endAt)}`}</option>)}
                    </select>
                    {requiredErrorWrapper(errors.time, 'Vi må vite når du vil ha time')}
                </div>
                <div className="cop__sub-header">Har du noen spesielle behov, eller er det noe annet vi burde vite før timen? (valgfritt)</div>
                <div className="small-12 store-field-wrapper">
                    <textarea className="expanded cop__big-text-container" autoComplete="off"
                        value={bookingData.customerMessage || ''}
                        onChange={(event) => onBookingDataChange('customerMessage', event.target.value)} />
                </div>
                <div className={`${isFullForm ? "cop__separator" : ""}`} />
                <div className={`store-booking-details ${isFullForm ? "visible" : ""}`} >
                    <div className="small-12 cop__header">Fornavn</div>
                    <div className="small-6 store-field-wrapper">
                        <input className={`store-field fc-primary ${errors.customerFirstName && errors.customerFirstName.type ? "store-field-with-error" : ""}`} type="email" autoComplete="off"
                            value={bookingData.customerFirstName || ''}
                            onChange={(event) => onBookingDataChange('customerFirstName', event.target.value)} />
                        {requiredErrorWrapper(errors.customerFirstName, 'Skriv inn fornavnet ditt')}
                    </div>
                </div>
                <div className={`store-booking-details ${isFullForm ? "visible" : ""}`} >
                    <div className="small-12 cop__header">Etternavn</div>
                    <div className="small-6 store-field-wrapper">
                        <input className={`store-field fc-primary ${errors.customerLastName && errors.customerLastName.type ? "store-field-with-error" : ""}`} type="email" autoComplete="off"
                            value={bookingData.customerLastName || ''}
                            onChange={(event) => onBookingDataChange('customerLastName', event.target.value)} />
                        {requiredErrorWrapper(errors.customerLastName, 'Skriv inn etternavn')}
                    </div>
                </div>
                <div className={`store-booking-details ${isFullForm ? "visible" : ""}`} >
                    <div className="small-12 cop__header">Mobilnummer</div>
                    <div className="small-6 store-field-wrapper">
                        <input className={`store-field fc-primary ${errors.customerPhone && errors.customerPhone.type ? "store-field-with-error" : ""}`} type="search" autoComplete="off"
                            onChange={(event) => onBookingDataChange('customerPhone', event.target.value)} />
                        {requiredErrorWrapper(errors.customerPhone, 'Vi trenger telefonnummeret ditt for å sende bekreftelse på timen')}
                        {lengthErrorWrapper(errors.customerPhone, 'Telefonummeret må ha 8 siffer')}
                    </div>
                </div>
                <div className={`store-booking-details ${isFullForm ? "visible" : ""}`} >
                    <div className="small-12 cop__header">E-post (valgfritt)</div>
                    <div className="small-6 store-field-wrapper">
                        <input className={`store-field fc-primary ${errors.customerEmail && errors.customerEmail.type ? "store-field-with-error" : ""}`} type="email" autoComplete="off"
                            value={bookingData.customerEmail || ''}
                            onChange={(event) => onBookingDataChange('customerEmail', event.target.value)} />
                        {requiredErrorWrapper(errors.customerEmail, 'Har du skrevet e-posten riktig?')}
                        {emailErrorWrapper(errors.customerEmail, 'Har du skrevet e-posten riktig?')}
                    </div>
                </div>

                <div className={`store-booking-details ${isFullForm ? "visible" : ""}`} >
                    <div className="small-12 cop__header_with_sub">Fødselsdato (valgfritt)</div>
                    <div className="cop__sub-header">{translate('coptikk.homepage_bookingappointment.birthdate.description')}</div>
                    <div className="small-8">
                        <div className="fc-primary custom__wrapper" >
                            <div className='store-field-wrapper'>
                                <div className='custom__input__header'>Dag (dd)</div>
                            </div>
                            <div className='store-field-wrapper'>
                                <div className='custom__input__header'>Måned (mm)</div>
                            </div>
                            <div className='store-field-wrapper'>
                                <div className='custom__input__header'>År (åååå)</div>
                            </div>
                        </div>
                        <div className="fc-primary store-field custom__wrapper">
                            <div className='store-field-wrapper'>
                                <input className='custom__input' type='number' placeholder='dd' min="1" max="31" step="1" onBlur={dayOfTheMonth('dd', 2)} onChange={(event) => onBookingDataChange('dd', event.target.value)} />
                            </div>
                            <div className='store-field-wrapper'>
                                <input className='custom__input' type='number' placeholder='mm' min="1" max="12" step="1" onBlur={dayOfTheMonth('mm', 2)} onChange={(event) => onBookingDataChange('mm', event.target.value)} />
                            </div>
                            <div className='store-field-wrapper'>
                                <input className='custom__input' type='number' placeholder='åååå' min="1900" max="9999" step="1" onBlur={dayOfTheMonth('yyyy', 4)} onChange={(event) => onBookingDataChange('yyyy', event.target.value)} />
                            </div>
                        </div>
                        {requiredErrorWrapper(errors.startDate, 'Skriv inn navnet ditt')}
                    </div>

                    <div className="small-12">
                        <button type="button" className="button expanded return-btn return-btn-step" onClick={() => bookingRequest()}>{translate('coptikk.homepage_bookingappointment.buttontext.confirmation')}</button>
                    </div>
                </div>
            </form>
        </>
    }
    const formatDate = (date) => {
        const tempDate = new Date(date);
        return String(tempDate.getHours()).padStart(2, '0') + ':' + String(tempDate.getMinutes()).padStart(2, '0');
    };

    const getStoreFormData = (params) => {
        setFormParams(params);
        setBookingData({});
        setSelectedDayTimes(null);
        setSelectedDay(null);
        setIsSuccessForm(false);
        setErrors({});
        setAvailableDates([], dispatch);
        setValidationOnChanges(false);
    }

    const validate = async () => {
        const bookingSchema = object().shape({
            optician: string().required(translate(`validation.required`)),
            resourceId: string().required(translate(`validation.required`)),
            date: string().required(translate(`validation.required`)),
            customerPhone: string().required(translate(`validation.required`)).matches(/^[0-9]+$/, "Must be only digits").min(8, 'Must be exactly 8 digits').max(8, 'Must be exactly 8 digits'),
            customerEmail: string().email(),
            //time: string().required(translate(`validation.required`)),
            customerFirstName: string().required(translate(`validation.required`)),
            customerLastName: string().required(translate(`validation.required`)),
            customerMessage: string().nullable(),
        });
        return await bookingSchema.validate(bookingData, { abortEarly: false })
            .then(() => {
                setErrors({});
                return true;
            })
            .catch(error => {
                console.error(error);
                setErrors(error.inner.map(({ path, type }) => ({ [path]: { type } })).reduce((r, c) => ({ ...r, ...c })));
                return false;
            });
    }

    const bookingRequest = async () => {
        const valid = await validate();
        if (valid) {
            const memberId = member.memberId;
            const { startAt, resource } = bookingData.time;
            const resourceId = bookingData.resourceId === "ANY" ?  null : resource.resourceId;
            const bookingTypeId = formParams.bookingTypeId;
            const message = bookingData.customerMessage;
            const sendSmsConfirmation = true;
            const firstName = bookingData.customerFirstName;
            const lastName = bookingData.customerLastName;
            const phoneNumber = bookingData.customerPhone;
            const email = bookingData.customerEmail;
            const ssn = bookingData.dd && bookingData.mm && bookingData.yyyy && String(bookingData.dd).padStart(2, "0") + String(bookingData.mm).padStart(2, "0") + bookingData.yyyy.substring(2, 4);
            createNewBooking({ memberId, startAt, resourceId, bookingTypeId, message, sendSmsConfirmation, firstName, lastName, phoneNumber, email, ssn }).then((resp) => {
                setSuccessFormData(JSON.parse(resp[0].title));
                setIsSuccessForm(true);
                if (window != null && window.dataLayer != null) {
                    let trackingObject = {
                        event: "booking_complete",
                        booking_data: {
                            dateTime: bookingData.time,
                            resource: resourceId,
                            type: bookingTypeId
                        },
                        storeId: storeIdConverter(currentStore.storeId).withC,
                        storeName: currentStore.storeName
                    };
                    console.log(trackingObject);
                    window.dataLayer.push(trackingObject);
                }
            });
        } else {
            setValidationOnChanges(true);
        }
    }
    const searchParams = (new URLSearchParams(window.location.search)).get('single');
    return isSuccessForm ? <div className="cop cop__booking-form columns">{successForm(successFormData, currentStore, onReturn)}</div> :
        <div className="cop cop__booking-form columns">
            {showMember && !searchParams ? <>
                <button type="button" className="button return-btn" onClick={onReturn}>
                    <span className="small-arrow ic ic-left-arrow" /> {translate('select_optician.name')}
                </button>
            </> : null}
            <div className="member-label">Hva ønsker du time for?</div>
            {(selectCurrentMembers(currentMembers, getStoreFormData))}
            {formParams.memberId ? (storeForm(true, bookingRequest)) : null}
        </div>;




};

export default BookingFormEmbedded;